import { render, staticRenderFns } from "./CoveragePagePeriod.vue?vue&type=template&id=c09cfe96"
import script from "./CoveragePagePeriod.vue?vue&type=script&lang=js"
export * from "./CoveragePagePeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports